
import './App.css';

function App() {
  return (
    <div className="App">
      Welcome to the neat denims
    </div>
  );
}

export default App;
